/*
 * @Author: Shirtiny
 * @Date: 2021-06-08 17:06:55
 * @LastEditTime: 2021-06-10 10:58:00
 * @Description:
 */
import React, { useState, useCallback, useEffect } from "react";
import styled from "styled-components";
import { Switch, Route, Redirect } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Header from "components/header";
import guide from "services/guide";
import "./App.css";
import SideTips from "components/sideTips";
import data from "services/data";
import SideNavBar from "components/sideNavBar";

const StyledApp = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.app.paddingTopBottom} 0;
  background-color: ${({ theme }) => theme.backgroundColor};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledMain = styled.div`
  display: flex;
  column-gap: 12px;
`;

const StyledAside = styled.aside`
  width: ${({ theme }) => theme.aside.width};
`;

const StyledAsideInner = styled.div`
  position: fixed;
  width: ${({ theme }) => theme.aside.width};
  top: ${({ theme }) => theme.app.paddingTopBottom};
  display: flex;
  flex-direction: column;
  row-gap: 13px;
`;

const StyledContent = styled.div`
  width: 1220px;
  display: flex;
  justify-content: center;
`;

// user对象的属性
// user = {
//   userName,
//   token,
//   loginDate
// }

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (user) {
      setUser(user);
      data.setToken(user.token);
    }
  }, []);

  const handleLogin = useCallback((loginedUser) => {
    setUser(loginedUser);
    data.setToken(loginedUser.token);
    sessionStorage.setItem('user', JSON.stringify(loginedUser));
  }, []);

  const handleLogout = useCallback(async () => {
    try {
      await data.removeAuthorization();
    }catch(e){
      console.log(e);
    }finally {
      setUser(null);
      data.removeToken();
      sessionStorage.removeItem('user');
    }
  }, []);

  return (
    <StyledApp>
      <Toaster />
      <StyledMain>
        <StyledAside>
          <StyledAsideInner>
            <Header />
            <SideTips
              onLogin={handleLogin}
              onLogout={handleLogout}
              user={user}
            />
            <SideNavBar />
          </StyledAsideInner>
        </StyledAside>
        <StyledContent>
          <Switch>
            {guide.barItems.map((item) => (
              <Route key={item.path} path={item.path}>
                <item.component user={user} />
              </Route>
            ))}
            <Redirect exact from="/" to={guide.defaultPath} />
            <Redirect to={guide.path404} />
          </Switch>
        </StyledContent>
      </StyledMain>
    </StyledApp>
  );
}

export default App;
